import { IAIImageModel, IAIImageProject } from 'store/types/aiImage'
import { DEFAULT_STYLE_NAME } from '../../consts'

export const reconstructAiImageHistoryItemData = (
  item: IAIImageProject,
  modelsData: IAIImageModel[]
) => {
  const modelName = modelsData.find(model => model.code === item.model)?.name

  const styleTag =
    item.styleName === DEFAULT_STYLE_NAME
      ? []
      : [
          {
            name: item.styleName,
            id: item.images[0].id.toString()
          }
        ]

  const modelTag = modelName
    ? [
        {
          name: modelName,
          id: item.model
        }
      ]
    : []

  const tags = [...styleTag, ...modelTag]
  return {
    ...item,
    tags
  }
}
